
  import { defineComponent } from 'vue';

  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';

  export default defineComponent({
    name: 'VedExportButtons',
    emits: ['exportExcel', 'exportPdf'],
    components: {
      ExportButtons,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      excelPermissionCode: {
        type: Number,
      },
    },
    computed: {
      getPermissionCodes() {
        return {
          excel: this.excelPermissionCode,
        };
      },
    },
    methods: {
      exportExcel() {
        this.$emit('exportExcel');
      },
      exportPdf() {
        this.$emit('exportPdf');
      },
    },
  });
